/* eslint-disable */
import React, { useState } from "react";
import Button from "antd/es/button";
import Checkbox from "antd/es/checkbox";
import Form from "antd/es/form";
import Input from "antd/es/input";
import Alert from "antd/es/alert";
import Tooltip from "antd/es/tooltip";
import Typography from "antd/es/typography";
import Image from "antd/es/image";
import "./index.css";
import mainLogo from "../../assets/logo-bpom.png";
import downloadJuknis from "../../assets/juknis-crop.png";
import supabase from "../../utils/supabaseClient";

const LoginPage = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);

  const onFinish = async (values) => {
    const { username, password } = values;
    setIsLoading(true);
    setError(false);

    try {
      const { data, error } = await supabase
        .from("industries")
        .select("*")
        .eq("username", username)
        .eq("password", password)
        .eq("status", 1); // Tambahin ini

      if (error) throw error;

      if (data.length === 0) {
        setError(true);
        setErrorMessage("Username, password, or status is incorrect.");
      } else {
        console.log("Login successful:", data[0]);
        window.open(data[0].link_industry, "_blank");
      }
    } catch (err) {
      setError(true);
      setErrorMessage("Error during login, please try again.");
      console.error("Login error:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    setErrorMessage("Username dan Password tidak valid");
  };

  const messagePerpanjangan = () => (
    <span>
      Diberitahukan kepada seluruh industri farmasi bahwa pengisian{" "}
      <strong>Tools Assessment Maturitas Industri Farmasi 2025</strong> harap
      diselesaikan selambat-lambatnya pada tanggal{" "}
      <strong>11 April 2025</strong>. Adapun unggah (upload) data dukung masih
      dapat dilakukan hingga tanggal <strong>18 April 2025</strong>. Atas
      perhatian dan kerja samanya, kami ucapkan terima kasih.
    </span>
  );

  return (
    <div
      className="container login-container"
      style={{
        margin: "0 5vw",
        maxWidth: "90vw",
      }}
    >
      <div className="row">
        <div
          className="col-md-12 mb-2 pb-2 pt-4"
          style={{ textAlign: "center" }}
        >
          <img src={mainLogo} className="logo-login" alt="fireSpot" />
          <div>
            <h4 className="mt-2 mb-1">
              <a href="">
                <i>Tools Assessment</i> Maturitas Industri Farmasi Tahun 2025
              </a>
            </h4>
            <h4
              style={{
                fontFamily: '"Open Sans", sans-serif',
                color: "#576971",
              }}
            >
              Direktorat Pengawasan Produksi Obat Narkotika Psikotropika dan
              Prekursor
            </h4>
            <p
              className="mx-1"
              style={{
                fontFamily: '"Open Sans", sans-serif',
                color: "#576971",
                marginTop: "20vh !important",
              }}
            >
              Masukan username dan password untuk mengakses Tools Assessment
              masing masing Industri Farmasi
            </p>
          </div>
        </div>
        <div className="col-md-10">
          <Form
            name="basic"
            labelCol={{
              span: 8,
            }}
            wrapperCol={{
              span: 16,
            }}
            initialValues={{
              remember: true,
            }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
            className="ant-form-horizontal"
            size="large"
          >
            <Form.Item className="label-white" label="_">
              <Alert
                message={messagePerpanjangan()}
                type="warning"
                showIcon
                className="custom-alert-green mb-2 mt-2"
                style={{ textAlign: "left" }}
              />
              {error ? (
                <Alert
                  message={errorMessage}
                  type="error"
                  showIcon
                  className="mb-2"
                />
              ) : (
                ""
              )}
              <Alert
                message="Pastikan Anda menggunakan browser yang sudah login dengan akun Gmail yang sama saat registrasi akun. Jika Anda login dengan akun lain, akses ke Tools Assessment mungkin tidak tersedia."
                type="info"
                showIcon
                className="mb-2 mt-2"
                style={{ textAlign: "left" }}
              />
            </Form.Item>
            <Form.Item
              label="Username"
              name="username"
              rules={[
                {
                  required: true,
                  message: "Please input your username!",
                },
              ]}
            >
              <Input style={{ textAlign: "left", height: "50px" }} />
            </Form.Item>

            <Form.Item
              label="Password"
              name="password"
              rules={[
                {
                  required: true,
                  message: "Please input your password!",
                },
              ]}
            >
              <Input.Password style={{ textAlign: "left", height: "50px" }} />
            </Form.Item>

            {/* <Form.Item
                            name="remember"
                            valuePropName="checked"
                            wrapperCol={{
                                offset: 8,
                                span: 16,
                            }}
                        >
                            <Checkbox>Remember me</Checkbox>
                        </Form.Item> */}

            <Form.Item
              wrapperCol={{
                offset: 8,
                span: 16,
              }}
              style={{ textAlignLast: "left" }}
            >
              <Button type="primary" htmlType="submit" loading={isLoading}>
                Login
              </Button>
            </Form.Item>
            <Form.Item
              wrapperCol={{
                offset: 8,
                span: 16,
              }}
              style={{ textAlignLast: "left" }}
            >
              <Alert
                message="Pendaftaran akun sudah ditutup untuk saat ini."
                type="error"
                showIcon
                className="mb-2"
              />
            </Form.Item>

          </Form>
          <Tooltip title="Register Akun">
            <Typography.Link href="/">
              Belum mempunyai akun? klik disini untuk Mendaftar
            </Typography.Link>
          </Tooltip>

        </div>
        <div className="col-md-2"></div>
        <div className="col-md-3 mt-4"></div>
        <div className="col-md-6 mt-4">
          <figure class="snip1205 green">
            <img src={downloadJuknis} />
            <i class="ion-android-download"></i>
            <a
              href="https://drive.google.com/file/d/11aSyOYVC2m7uo_ORLOfcQKGB5JcUn4B0/view?usp=drive_link"
              target="_blank"
            ></a>
          </figure>
        </div>
        <div className="col-md-3 mt-4"></div>
      </div>
    </div>
  );
};

export default LoginPage;
